import { DARK_BLUE, DEFAULT_BG_COLOR, MAIN_COLOR, MAIN_TEXT_COLOR } from 'shared/consts/styleValues';
import styled from 'styled-components';

export const LogoText = styled.div`
	font-family: 'Fredoka', sans-serif;
	font-weight: 800;
	color: ${MAIN_COLOR};
	font-size: 24px;
  margin: 24px 0;

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
`;

export const LogoBlock = styled.div`
  font-family: 'Museo Cyrl';
  --font-size: 22px;
  padding: 9.5px 11px;
  border-radius: calc(1px / 0);
  border: 1px solid ${MAIN_TEXT_COLOR};
  background-color: ${DEFAULT_BG_COLOR};
  color: ${DARK_BLUE};

  >*, & {
    font-size: var(--font-size);
    letter-spacing: calc((var(--font-size) / 100) * -1);
  }

  span {
    --font-size: 19px;
    color: ${MAIN_TEXT_COLOR};
  }
`